import { createAction } from '@/utility/actions';

import { IP_API_GET_IP_INFO } from './types';

export const getIpInfo = createAction(IP_API_GET_IP_INFO);

export default {
  getIpInfo,
};
